// extracted by mini-css-extract-plugin
module.exports = {"main":"DefaultLayout_main__19xJq","layout":"DefaultLayout_layout__3c-Oy"};